import React, { Fragment } from 'react';
import {
	Button,
	Dropdown,
	Form,
	Modal,
	TextArea,
	Table,
	Checkbox,
	Popup,
	Icon,
	Dimmer,
	Loader
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import * as styles from './styles.js';
import { observable, toJS } from 'mobx';
import type { AssignableUser } from 'stores/Account';
import Account from 'stores/Account';
import MessageBox from 'components/MessageBox';
import MsgStore from 'stores/MsgStore';
import UiShared from 'stores/UiShared';
import DayPickerInput from 'components/DayPickerInput';
import { IObservableArray, extendObservable } from 'mobx/lib/mobx';

export type ManagerItem = AssignableUser | { checked: boolean };

@inject(rootStore => ({
	auth: rootStore.auth,
	uiShared: rootStore.uiShared
}))
@observer
export default class NotifyPrescriber extends React.Component {
	props: {
		isOpen: boolean,
		onRequestClose: () => {},
		auth?: Auth,
		uiShared: UiShared
	};

	static defaultProps = {
		isOpen: false
	};

	@observable managers: IObservableArray<ManagerItem> = [];
	@observable loading: boolean = false;

	componentDidUpdate = async prevProps => {
		try {
			if (this.props.isOpen && !prevProps.isOpen) {
				this.msgStore.clear();
				this.loading = true;
				const userId = this.props.auth?.user.id;
				const managers = await Account.getManagers(userId);
				this.managers = managers.map(el => extendObservable(el, { checked: false }));
				this.loading = false;
			}
		} catch (e) {
			this.msgStore.setError(e);
		}
	};

	msgStore: MsgStore = new MsgStore();

	toggleCheckboxes() {
		let allSelected = this.managers.every(el => el.checked);

		if (allSelected) {
			this.managers.forEach(el => {
				el.checked = false;
			});
		} else {
			this.managers.forEach(el => {
				el.checked = true;
			});
		}
	}

	reset = () => {
		this.managers = [];
		this.msgStore.clear();
	};

	onClose = () => {
		this.reset();
		this.props.onRequestClose();
	};

	notifyPrescriber = async () => {
		try {
			if (this.managers.length < 1) return;
			const { uiShared } = this.props;
			const ids = this.managers.filter(el => el.checked).map(el => el.id);
			uiShared.showModal('Sending the notification...');
			await Account.notifyPrescriber(ids);
			uiShared.showModal('The notification was sent', {
				actions: [
					<Button
						key="1"
						onClick={() => {
							uiShared.hideModal();
							this.onClose();
						}}
					>
						Close
					</Button>
				]
			});
		} catch (e) {
			uiShared.hideModal();
			this.msgStore.setError(err);
		}
	};

	render() {
		const { isOpen, uiShared } = this.props;
		const { onClose, loading, managers, msgStore } = this;

		return (
			<Modal open={isOpen} size="small" onClose={onClose} className={styles.modalCont}>
				<Fragment>
					<Dimmer active={loading} inverted>
						<Loader content="Loading" />
					</Dimmer>
					<Modal.Header>Notify Prescriber</Modal.Header>
					<Modal.Content>
						<Form>
							<Table basic="very">
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell textAlign="center" width="2">
											<Popup
												trigger={
													<Icon
														name="check square outline"
														size="large"
														link
														onClick={() => {
															this.toggleCheckboxes();
														}}
													/>
												}
												content="Select/Deselect all"
											/>
										</Table.HeaderCell>
										<Table.HeaderCell>Select All</Table.HeaderCell>
										<Table.HeaderCell>Last time modified</Table.HeaderCell>
									</Table.Row>
								</Table.Header>
								<Table.Body>
									{managers.map((el: ManagerItem, idx) => (
										<Table.Row key={idx}>
											<Table.Cell textAlign="center">
												<Checkbox
													checked={el.checked}
													onChange={() => {
														el.checked = !el.checked;
													}}
												/>
											</Table.Cell>
											<Table.Cell>{(el.title || '') + `${el.firstName} ${el.lastName}`}</Table.Cell>
											<Table.Cell>{el.created?.toDate().format('DD/MM/YY HH:mm:ss')}</Table.Cell>
										</Table.Row>
									))}
								</Table.Body>
							</Table>
							<div>
								<MessageBox msgStore={msgStore} />
								<div className={styles.buttonsRowSpaced}>
									<div />
									<div>
										<Button
											primary
											disabled={managers.filter(el => el.checked).length === 0}
											onClick={() => {
												this.notifyPrescriber();
											}}
										>
											Notify
										</Button>
										<Button onClick={onClose}>Close</Button>
									</div>
								</div>
							</div>
						</Form>
					</Modal.Content>
				</Fragment>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/User/NotifyPrescriber.js